var _style, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlliedHealthProfessionals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "allied-health-professionals_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M382.2 625.9h109.4v69.3h69.5v110h-69.3v69.1H382.2v-69.2h-69.5V695.3h69.2v-69.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 659.3,
    cy: 371.7,
    r: 32.6,
    fill: "#35A4DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E30613",
    d: "M691.9 467.1c0-1.2-.1-2.4-.2-3.6v7.1c.1-1.1.2-2.3.2-3.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M877.4 531.4l-17.8-14.8c-22.2-20.5-51-31.7-81.2-31.7-2.7 0-5.5.1-8.2.3-29.7 2.2-57.6 15.3-78.3 36.5v-58.1c-1.8-16.3-15.6-29-32.4-29-15.9 0-29.1 11.4-32 26.4v12.5l.1 137.5c0 13.6 8.6 25.7 21.4 30.3 3.5 1.2 7.1 1.9 10.8 1.9 9.7 0 18.7-4.3 24.9-11.8L734 571l.1-.1.1-.1c9.9-12.4 24.6-20.2 40.4-21.4 1.2-.1 2.4-.1 3.6-.1 14.2 0 27.7 5.3 38.1 15.1l-165 316.8c-23.9 46-69.1 74.6-117.8 74.6H335c-74.5 0-135.2-65.8-135.3-146.7-.2-184.1-.3-390.1-.1-505.5 0-18.1 13-32.7 28.9-32.7h1.4c7.6 0 14.8 3.2 20.2 9 5.8 6.1 9 14.5 9 23.4v213.1c0 17.8 14.4 32.2 32.2 32.2s32.2-14.4 32.2-32.2V154.8c0-18.4 12.8-33.3 28.6-33.3 15.7 0 28.5 14.9 28.5 33.3v361.5c0 17.8 14.4 32.2 32.2 32.2 17.8 0 32.2-14.4 32.2-32.2V101.1c0-9 3.2-17.4 9.1-23.7 5.6-5.9 12.8-9.2 20.4-9.2h1.4c16 0 28.9 14.8 28.9 33.1V516.5c.1 17.7 14.5 32.1 32.2 32.1h.1c8.6 0 16.7-3.4 22.8-9.5 6.1-6.1 9.4-14.2 9.4-22.8V325.1 194.5c.4-8.7 3.7-16.8 9.4-22.8 5.4-5.7 12.3-8.8 19.6-8.8 15.9 0 28.9 14.9 28.9 33.3l.1 74.7v11c2.6 15.4 16 27.1 32.1 27.1 16.5 0 30.1-12.2 32.3-28v-9.2l-.1-75.6c0-53.8-42.1-97.6-93.7-97.6-10.1 0-19.7 1.6-29.3 5v-2.3c0-25.9-9.5-50.2-26.6-68.5-17.6-18.7-41-29-66.1-29h-1.4C451.9 3.8 430 12.4 413 28c-11.1 10.1-19.6 22.7-25 36.8-11.2-4.9-23.4-7.5-35.7-7.5-25.1 0-48.6 10.3-66.2 28.9-17.4 18.4-27 42.8-27 68.7v55.9c-9.1-2.9-19-4.4-29.2-4.4h-1.4c-25 0-48.5 10.2-66.1 28.6-17.5 18.3-27.1 42.6-27.2 68.4-.3 115.5-.1 321.6.1 505.7 0 28.4 5.3 55.9 15.7 81.9 10 25.1 24.4 47.7 42.6 67 18.3 19.4 39.7 34.7 63.5 45.4 24.7 11.1 50.9 16.7 77.9 16.7h198.5c72.8 0 139.8-41.9 174.9-109.2l177-339.9c7-13.4 3.6-30-8-39.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlliedHealthProfessionals);
export default ForwardRef;